import { createApiClient } from "@/api";

const apiClient = createApiClient("json");
const BASE_URL = "/api/vpn/device_type_models";

const fetchListData = async () => {
  const response = await apiClient.GET(BASE_URL);
  const data = response.data ?? [];

  return {
    data,
    total: data.length,
  };
};

export const deviceTypesSchema = {
  list: fetchListData,
};
